/* eslint-disable no-undef */
import { post } from '../helper/xhrAPI'
import { createAlert, renderErrors } from '../helper/formSubmission'
import { MenuManager } from './component/front/front-helpers/MenuManager'

document.addEventListener('DOMContentLoaded', e => {
  MenuManager()

  document.getElementById('subscribe-button').addEventListener('click', e => {
    e.target.classList.add('is-loading')
    e.preventDefault()
    e.target.classList.add('is-loading')
    grecaptcha.ready(function () {
      grecaptcha.execute(`${e.target.getAttribute('data-sitekey')}`, { action: 'submit' }).then(function (token) {
        const data = new FormData(document.getElementById('register-form'))
        post('/user', data, response => {
          e.target.classList.remove('is-loading')
          createAlert(typeof response.error !== 'undefined', response.msg, '.subscription-zone', '#register-form')
          if (typeof response.error !== 'undefined') {
            renderErrors(response.errors, '#register-form')
          } else {
            setTimeout(() => {
              window.location.href = response.redirectTo
            }, 2000)
          }
        })
      })
    })
  })
})
